import React from 'react'
import styled from 'styled-components'
import intl from 'react-intl-universal'
import { Row, Column } from '../grid'
import { Title, NavAnchor, NavLink, PostCardsContainer, DeusColumn } from './atoms'
import Email from './email'
import NewMedia from '../../theme/new-media'
import { StaticImage } from 'gatsby-plugin-image'
import { useMedia } from '../../hooks'
import ISO from './images/ISO.png'
import TPN from './images/TPN.png'
import HIPAA from './images/HIPAA.png'
import RedHat from './images/RedHat.png'
import Cer from './images/cer@1x.png'
import Sns from './new-sns'

const EnNavLink = styled(NavLink)`
  color: #999999;
  &:hover {
    color: #fd5c1f !important;
  }
  ${NewMedia.phone`
    font-size: .24rem;
    width: 2.5rem;
    line-height: .30rem;
    margin-bottom: .4rem;
  `}
`
export const EnNavAnchor = styled(NavAnchor)`
  color: #999999;
  font-size: 14px;
  ${NewMedia.phone`
      font-size: .24rem;
    `}
`
const ImgBox = styled.div`
  display: flex;
  transform: translateY(-10px);
  img {
    width: 80px;
    height: 100px;
    &:last-child {
      margin-left: 20px;
    }
  }
`
export const EnNavAnchorPlain = styled(EnNavAnchor)``

const currentPackageName = process.env.GATSBY_PACKAGE_NAME
const isInMain = currentPackageName === 'main'
const isInNews = currentPackageName === 'news'
const isInSupport = currentPackageName === 'support'
// const Mark = styled.span`
//   color: ${p => p.theme.color.secondary};
// `
const locale = intl.getInitOptions().currentLocale
const testimonials = [
  { titleImg: ISO, description: 'ISO 27001 Certification' },
  { titleImg: TPN, description: 'TPN Verified' },
  { titleImg: HIPAA, description: 'HIPAA Verified' },
  { titleImg: RedHat, description: 'Red Hat' },
]
const EnPostCards = () => {
  let isMedia = useMedia()
  return !isMedia ? (
    <PostCardsContainer>
      <Row>
        {/* products */}
        <DeusColumn lg='3.00' xs='3.00'>
          <Title>{intl.get('app.footer.product.title')}</Title>
          <EnNavLink isInternal={isInMain} to='/enterprise/'>
            {intl.get('enterprise.link')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/raysync-cloud/'>
            {intl.get('cloud.link')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/smb/'>
            {intl.get('app.footer.product7')}
          </EnNavLink>
        </DeusColumn>
        {/* Company */}
        <DeusColumn lg='2.23' xs='2.23'>
          <Title>{intl.get('app.header.company')}</Title>
          <EnNavLink isInternal={isInMain} to='/about-us'>
            {intl.get('app.header.company.about')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/partners/'>
            {intl.get('app.header.agent')}
          </EnNavLink>
          <EnNavLink isInternal={isInNews} to='/news/'>
            {intl.get('app.footer.entry2')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/privacy-policy/'>
            {intl.get('app.footer.entry6')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/terms-of-service'>
            {'Terms Of Service'}
          </EnNavLink>
        </DeusColumn>
        {/* Concact-us */}
        <Column lg='2.57' xs='2.57' sm='8'>
          <Title locale={locale} phoneFontSize={24}>
            {intl.get('app.footer.contact')}
          </Title>
          <EnNavAnchor
            rel='noopener noreferrer nofollow'
            href={`mailto:${intl.get('app.contact.email.value')}`}
            locale={locale}
            phoneFontSize={20}
          >
            {`${intl.get('app.footer.contact.email')}: ${intl.get('app.contact.email.value')}`}
          </EnNavAnchor>
          <EnNavAnchorPlain
            rel='noopener noreferrer nofollow'
            href={`https://www.linkedin.com/in/angelachan-285906157/`}
            locale={locale}
            phoneFontSize={20}
            target='_blank'
          >
            {`${intl.get('app.footer.contact.qq')}: ${intl.get('app.footer.contact.qqnumber')}`}
          </EnNavAnchorPlain>
        </Column>
        <Column lg='2.2' xs='2.2'>
          <img src={Cer} />
        </Column>
      </Row>
      <Row style={{ paddingTop: '30px' }}>
        {/* Solutions */}
        <DeusColumn lg='3.00' xs='3.00'>
          <Title>{intl.get('app.header.solution')}</Title>
          <EnNavLink isInternal={isInMain} to='/solutions/petabyte-scale-data-transfer/'>
            {intl.get('app.footer.solution9')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/massive-file-transfer/'>
            {intl.get('app.footer.solution19')}
          </EnNavLink>

          <EnNavLink isInternal={isInMain} to='/solutions/data-migration-data-sync-and-data-backup/'>
            {intl.get('app.footer.solution12')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/p2p-large-scale-file-transfer/'>
            {intl.get('app.footer.solution17')}
          </EnNavLink>

          <EnNavLink isInternal={isInMain} to='/solutions/file-management/'>
            {intl.get('app.footer.solution14')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/data-collaboration-and-secure-file-sharing/'>
            {intl.get('app.footer.solution13')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/sdk-and-api-intergration/'>
            {intl.get('app.footer.solution20')}
          </EnNavLink>
        </DeusColumn>

        {/* Industry Solutions */}
        <DeusColumn lg='2.23' xs='2.23'>
          <Title>{intl.get('app.header.industries')}</Title>

          <EnNavLink isInternal={isInMain} to='/solutions/industry-financing/'>
            {intl.get('app.footer.solution3')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-gene/'>
            {intl.get('app.footer.solution4')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-car/'>
            {intl.get('app.footer.solution5')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-manufacturing/'>
            {intl.get('app.footer.solution6')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-internet/'>
            {intl.get('app.footer.solution7')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-media/'>
            {intl.get('app.footer.solution.media')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-marine/'>
            {intl.get('app.footer.solution.marine')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-gaming/'>
            {intl.get('app.footer.solution.gaming')}
          </EnNavLink>
        </DeusColumn>
        {/* Resources */}
        <DeusColumn lg='2.57' xs='2.57'>
          <Title>{intl.get('app.header.resources')}</Title>
          <EnNavLink isInternal={isInMain} to='/pricing/'>
            {intl.get('app.header.pricing')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/casestudies/'>
            {intl.get('app.footer.entry3')}
          </EnNavLink>
          <EnNavLink isInternal={isInSupport} to='/support/document/index/'>
            {intl.get('support.help-center')}
          </EnNavLink>
          <EnNavLink isInternal={isInSupport} to='/support/document/white-paper/'>
            {intl.get('app.header.resources.white-paper')}
          </EnNavLink>
          <EnNavLink isInternal={isInSupport} to='/support/document/video/Raysync/'>
            {intl.get('app.header.resources.video-tutorial')}
          </EnNavLink>
          <EnNavLink isInternal={isInSupport} to='/support/document/faq/Installation-issues/'>
            {intl.get('app.header.resources.faq')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/calculator/'>
            {intl.get('app.footer.calculator')}
          </EnNavLink>
        </DeusColumn>

        <DeusColumn lg='2.2' xs='2.2'>
          <Title>{intl.get('app.footer.subscribe')}</Title>
          <Email buttonStyle={{ width: 100, borderRadius: 6 }} />
          <Sns />
        </DeusColumn>
      </Row>
    </PostCardsContainer>
  ) : (
    <PostCardsContainer>
      <Row>
        {/* products */}
        <DeusColumn lg='6.6' xs='6.6'>
          <Title>{intl.get('app.footer.product.title')}</Title>
          <EnNavLink isInternal={isInMain} to='/enterprise/'>
            {intl.get('enterprise.link')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/raysync-cloud/'>
            {intl.get('cloud.link')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/smb/'>
            {intl.get('app.footer.product7')}
          </EnNavLink>
        </DeusColumn>
        {/* Concact-us */}
        <Column lg='5.4' xs='5.4'>
          <Title locale={locale} phoneFontSize={24}>
            {intl.get('app.footer.contact')}
          </Title>
          <EnNavAnchorPlain
            rel='noopener noreferrer nofollow'
            href={`https://www.linkedin.com/in/angelachan-285906157/`}
            locale={locale}
            phoneFontSize={20}
            target='_blank'
          >
            {`${intl.get('app.footer.contact.qq')}: ${intl.get('app.footer.contact.qqnumber')}`}
          </EnNavAnchorPlain>
          <EnNavAnchor
            rel='noopener noreferrer nofollow'
            href={`mailto:${intl.get('app.contact.email.value')}`}
            locale={locale}
            phoneFontSize={20}
          >
            {`${intl.get('app.footer.contact.email')}: ${intl.get('app.contact.email.value')}`}
          </EnNavAnchor>
        </Column>
      </Row>
      <Row>
        {/* Solutions */}
        <DeusColumn lg='6.6' xs='6.6'>
          <Title>{intl.get('app.header.solution')}</Title>
          <EnNavLink isInternal={isInMain} to='/solutions/petabyte-scale-data-transfer/'>
            {intl.get('app.footer.solution9')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/massive-file-transfer/'>
            {intl.get('app.footer.solution19')}
          </EnNavLink>

          <EnNavLink isInternal={isInMain} to='/solutions/data-migration-data-sync-and-data-backup/'>
            {intl.get('app.footer.solution12')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/p2p-large-scale-file-transfer/'>
            {intl.get('app.footer.solution17')}
          </EnNavLink>

          <EnNavLink isInternal={isInMain} to='/solutions/file-management/'>
            {intl.get('app.footer.solution14')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/data-collaboration-and-secure-file-sharing/'>
            {intl.get('app.footer.solution13')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/sdk-and-api-intergration/'>
            {intl.get('app.footer.solution20')}
          </EnNavLink>
        </DeusColumn>

        {/* Industry Solutions */}
        <DeusColumn lg='5.4' xs='5.4'>
          <Title>{intl.get('app.header.industries')}</Title>

          <EnNavLink isInternal={isInMain} to='/solutions/industry-financing/'>
            {intl.get('app.footer.solution3')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-gene/'>
            {intl.get('app.footer.solution4')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-car/'>
            {intl.get('app.footer.solution5')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-manufacturing/'>
            {intl.get('app.footer.solution6')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-internet/'>
            {intl.get('app.footer.solution7')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-media/'>
            {intl.get('app.footer.solution.media')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-marine/'>
            {intl.get('app.footer.solution.marine')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/solutions/industry-gaming/'>
            {intl.get('app.footer.solution.gaming')}
          </EnNavLink>
        </DeusColumn>
      </Row>
      <Row>
        {/* Company */}
        <DeusColumn lg='6.6' xs='6.6'>
          <Title>{intl.get('app.header.company')}</Title>
          <EnNavLink isInternal={isInMain} to='/about-us'>
            {intl.get('app.header.company.about')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/partners/'>
            {intl.get('app.header.agent')}
          </EnNavLink>
          <EnNavLink isInternal={isInNews} to='/news/'>
            {intl.get('app.footer.entry2')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/privacy-policy/'>
            {intl.get('app.footer.entry6')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/terms-of-service'>
            {'Terms Of Service'}
          </EnNavLink>
        </DeusColumn>
        {/* Resources */}
        <DeusColumn lg='5.4' xs='5.4'>
          <Title>{intl.get('app.header.resources')}</Title>
          <EnNavLink isInternal={isInMain} to='/pricing/'>
            {intl.get('app.header.pricing')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/example/'>
            {intl.get('app.footer.entry3')}
          </EnNavLink>
          <EnNavLink isInternal={isInSupport} to='/support/document/index/'>
            {intl.get('support.help-center')}
          </EnNavLink>
          <EnNavLink isInternal={isInSupport} to='/support/document/white-paper/'>
            {intl.get('app.header.resources.white-paper')}
          </EnNavLink>
          <EnNavLink isInternal={isInSupport} to='/support/document/video/Raysync/'>
            {intl.get('app.header.resources.video-tutorial')}
          </EnNavLink>
          <EnNavLink isInternal={isInSupport} to='/support/document/faq/Installation-issues/'>
            {intl.get('app.header.resources.faq')}
          </EnNavLink>
          <EnNavLink isInternal={isInMain} to='/calculator/'>
            {intl.get('app.footer.calculator')}
          </EnNavLink>
        </DeusColumn>
      </Row>
      <Row>
        <DeusColumn lg='10' xs='10' style={{ marginBottom: '1rem' }}>
          <Title>{intl.get('app.footer.subscribe')}</Title>
          <Email buttonStyle={{ width: '3.7rem', borderRadius: 6 }} />
          <Sns />
        </DeusColumn>
      </Row>
    </PostCardsContainer>
  )
}

export default EnPostCards
